import moment from 'moment'
import Column from './Column'

export default class DateTimeColumn extends Column {
  render = row => moment(row[this.field]).format('DD/MM/YYYY HH:mm:ss')
}
